import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  headerNavigationItems: []
}

const headerSlice = createSlice({
  name: "headerNavigation",
  initialState,
  reducers: {
    fetchData: (state, action) => {
      // In RTK, action.payload is commonly used, but you can mimic your old shape
      state.headerNavigationItems = action.headerNavigation || action.payload?.headerNavigation || []
    }
  }
})

// Export the action creator
export const { fetchData } = headerSlice.actions

// Export the reducer
export default headerSlice.reducer
